import AppConfig from '@config';
import useLocalization from '@localizations';
import { Reservation, useAppContext } from '@store';
import { Clipboard, Platform, StyleSheet, View } from 'react-native';
import { FAB, Subheading, Text, useTheme } from 'react-native-paper';
import { getCombinedAddress, openMaps } from './MapHelper';

type LocationCardProps = {
  property: Reservation['property'];
};

export const LocationCard = ({ property }: LocationCardProps) => {
  const { t } = useLocalization();
  const { openSnackbar } = useAppContext();
  const theme = useTheme();

  const handleCopyAddress = async () => {
    try {
      if (
        Platform.OS === 'web' &&
        typeof navigator !== 'undefined' &&
        navigator.clipboard
      ) {
        await navigator.clipboard.writeText(getCombinedAddress(property));
      } else {
        Clipboard.setString(getCombinedAddress(property));
      }

      openSnackbar({
        title: t('copy_address_success'),
        color: AppConfig.Colors.SUCCESS,
      });
    } catch {
      openSnackbar({
        title: t('copy_address_error'),
        color: AppConfig.Colors.ERROR,
      });
    }
  };

  return (
    <View style={[AppConfig.Styles.border, styles.borderContainer]}>
      <View style={styles.addressContainer}>
        <Subheading numberOfLines={1}>{t('location')}</Subheading>
        <Text variant="bodySmall">{property.address}</Text>
      </View>
      <FAB
        style={[styles.fab, { backgroundColor: theme.colors.primary }]}
        color="white"
        icon="content-copy"
        onPress={handleCopyAddress}
      />
      <FAB
        style={[
          styles.fab,
          styles.mapFab,
          { backgroundColor: theme.colors.primary },
        ]}
        color="white"
        icon="map-marker"
        onPress={() => openMaps(property)}
      />
    </View>
  );
};

const styles = StyleSheet.create({
  borderContainer: {
    flexDirection: 'row',
    marginTop: AppConfig.Styles.getAdjustedSize(16),
    padding: AppConfig.Styles.getAdjustedSize(16),
    alignItems: 'center',
    justifyContent: 'space-between',
  },
  addressContainer: {
    flex: 1,
  },
  fab: {
    height: AppConfig.Styles.getAdjustedSize(40),
    width: AppConfig.Styles.getAdjustedSize(40),
    alignItems: 'center',
    justifyContent: 'center',
  },
  mapFab: {
    marginLeft: AppConfig.Styles.getAdjustedSize(16),
  },
});

export default LocationCard;
